(function () {
  var racine = null,
    cp = null,
    lienCookies = "/pages/cookies";
  function mesurer(action, essai) {
    if (window.mdsMesure) {
      try {
        window.mdsMesure("Consentement", action, location.pathname);
      } catch (e) {}
      return;
    }
    if ((essai || 0) < 10)
      setTimeout(function () {
        mesurer(action, (essai || 0) + 1);
      }, 1000);
  }
  function fabriquer() {
    if (racine) return racine;
    racine = document.createElement("section");
    racine.className = "cookie-banner";
    racine.hidden = true;
    racine.setAttribute("role", "dialog");
    racine.setAttribute("aria-labelledby", "mc-titre");
    racine.setAttribute("aria-live", "polite");
    racine.innerHTML =
      '<div class="cookie-banner__body">' +
      '<div class="cookie-banner__header"><span class="cookie-banner__icon" aria-hidden="true"><i class="ph ph-cookie"></i></span><h2 class="cookie-banner__title" id="mc-titre">Quelques cookies, avec votre accord</h2></div>' +
      '<p class="cookie-banner__court">Cookies de mesure et de publicité, seulement avec votre accord. <a href="' + lienCookies + '">En savoir plus</a></p><p class="cookie-banner__text">Avec votre accord, ils mesurent les visites et nos publicités. Votre panier et la commande fonctionnent sans eux. <a href="' +
      lienCookies +
      '">En savoir plus</a></p>' +
      '<div class="cookie-banner__actions"><button type="button" class="cookie-banner__button cookie-banner__button--decline" data-mc="refuser">Refuser</button><button type="button" class="cookie-banner__button cookie-banner__button--accept" data-mc="accepter">Accepter</button></div>' +
      '<button type="button" class="cookie-banner__toggle-details" data-mc="choisir" aria-expanded="false" aria-controls="mc-choix">Choisir <span class="cookie-banner__long">au cas par cas </span><i class="ph ph-caret-down" aria-hidden="true"></i></button>' +
      '<div class="cookie-banner__details" id="mc-choix"><div>' +
      '<div class="cookie-banner__row"><div><b>Nécessaires</b><span>Panier, paiement sécurisé, mémoire de votre choix.</span></div><span class="cookie-banner__always-on">Toujours actifs</span></div>' +
      '<div class="cookie-banner__row"><div><b>Mesure d’audience</b><span>Savoir quelles pages sont lues, pour améliorer le site.</span></div><label class="cookie-banner__switch"><input type="checkbox" data-mc-type="analytics" aria-label="Mesure d’audience"><i></i></label></div>' +
      '<div class="cookie-banner__row"><div><b>Publicité</b><span>Nos partenaires publicitaires suivent votre navigation pour vous montrer nos meubles sur d’autres sites.</span></div><label class="cookie-banner__switch"><input type="checkbox" data-mc-type="marketing" aria-label="Publicité"><i></i></label></div>' +
      '<button type="button" class="cookie-banner__button cookie-banner__button--save" data-mc="enregistrer">Enregistrer mes choix</button>' +
      "</div></div></div>";
    document.body.appendChild(racine);
    racine.addEventListener("click", function (e) {
      var b = e.target.closest("[data-mc]");
      if (!b) return;
      var a = b.getAttribute("data-mc");
      if (a === "accepter") {
        mesurer("Accepté");
        enregistrer(true, true);
      } else if (a === "refuser") {
        mesurer("Refusé");
        enregistrer(false, false);
      } else if (a === "enregistrer") {
        mesurer("Choix personnalisé");
        enregistrer(
          racine.querySelector('[data-mc-type="analytics"]').checked,
          racine.querySelector('[data-mc-type="marketing"]').checked,
        );
      } else if (a === "choisir") {
        var c = racine.querySelector(".cookie-banner__details"),
          ouvert = !c.classList.contains("is-open");
        c.classList.toggle("is-open", ouvert);
        b.setAttribute("aria-expanded", ouvert ? "true" : "false");
      }
    });
    racine.addEventListener("keydown", function (e) {
      if (e.key === "Escape") enregistrer(false, false);
    });
    return racine;
  }
  function ouvrir() {
    fabriquer();
    var etat = cp && cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
    racine.querySelector('[data-mc-type="analytics"]').checked = etat.analytics === "yes";
    racine.querySelector('[data-mc-type="marketing"]').checked = etat.marketing === "yes";
    racine.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        racine.classList.add("is-open");
      });
    });
  }
  function fermer() {
    if (!racine) return;
    racine.classList.remove("is-open");
    var r = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setTimeout(
      function () {
        racine.hidden = true;
      },
      r ? 0 : 450,
    );
  }
  function enregistrer(audience, pub) {
    fermer();
    if (!cp || !cp.setTrackingConsent) return;
    cp.setTrackingConsent(
      { analytics: audience, marketing: pub, preferences: audience, sale_of_data: pub },
      function () {},
    );
  }
  function sansReponse() {
    if (!cp || !cp.currentVisitorConsent) return false;
    var c = cp.currentVisitorConsent();
    return !c || c.analytics === "" || c.marketing === "";
  }
  window.MDSCookies = { ouvrir: ouvrir };
  document.addEventListener("click", function (e) {
    var lien = e.target.closest("[data-cookie-settings]");
    if (!lien) return;
    e.preventDefault();
    ouvrir();
  });
  function demarrer() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (err) return;
      cp = window.Shopify.customerPrivacy;
      if (window.MDS_INTERNE) {
        var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
        if (c.analytics !== "no" || c.marketing !== "no") enregistrer(false, false);
        return;
      }
      if (sansReponse())
        setTimeout(function () {
          ouvrir();
          mesurer("Bandeau affiché");
        }, 900);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
})();
